module.exports = __webpack_public_path__ + "static/media/1_09.38b7f91d.jpg";